export default "__VITE_ASSET__d8b0da22__"